import api from '../../services/api';

const resource = '/relatorios/';

const relatoriosService = {
  getOptions: async () => {
    try {
      const response = await api.get(resource + 'options/');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar opções de relatório:', error);
      throw error;
    }
  },

  getDuplicidades: async (params) => {
    try {
      const response = await api.get(resource + 'duplicidades/', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar duplicidades:', error);
      throw error;
    }
  },

  getDetalhes: async (params) => {
    try {
      const response = await api.get(resource + 'duplicidades/', { params: { ...params, mode: 'detalhes' } });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar detalhes da duplicidade:', error);
      throw error;
    }
  },

  exportDuplicidades: async (params) => {
      try {
          const response = await api.get(resource + 'duplicidades/', {
              params: { ...params, export: true },
              responseType: 'blob',
          });
          return response.data;
      } catch (error) {
          console.error('Erro ao exportar duplicidades:', error);
          throw error;
      }
  }
};

export default relatoriosService;
